import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Download } from "@mui/icons-material";
import { Button } from "@mui/material";
import CustomizedSnackbar from "./CustomizedSnackbar";

export const BasicTable = ({ title, rows }) => {
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const downloadFile = (id, fileName) => {
    fetch(
      `${process.env.REACT_APP_BASE_URL}/download/api?id=${encodeURIComponent(
        id
      )}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    )
      .then((response) => {
        if (
          response.headers.get("Content-Type") === "application/json, utf-8"
        ) {
          return response.json();
        } else {
          return response.blob();
        }
      })
      .then((data) => {
        let error = data["error"];

        if (error && error.length) {
          setMessage(error);
          handleClick();
        } else {
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          link.setAttribute("target", "_blank");

          document.body.appendChild(link);

          link.click();
          link.parentNode.removeChild(link);
        }
      });
  };

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>{title}</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.title}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.title}
              </TableCell>
              <TableCell align="right">
                {row.url && row.url.length ? (
                  <Button
                    variant="contained"
                    startIcon={<Download />}
                    onClick={() => downloadFile(row.id, row.title)}
                  >
                    Download
                  </Button>
                ) : (
                  row.value
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <CustomizedSnackbar
        severity="error"
        message={message}
        open={open}
        handleClose={handleClose}
      ></CustomizedSnackbar>
    </TableContainer>
  );
};

export default BasicTable;
